import { useContext } from 'react'
import ReactDom from 'react-dom'
import PropTypes from 'prop-types'
import IconButton from '@mui/material/IconButton'
import ClearIcon from '@mui/icons-material/Clear'
import { useSpring, animated, config } from 'react-spring'
import clsx from 'clsx'
import { StoreContext } from '../../store'
import Root, {
  classes,
  MODAL_DRAWER_HEADER_HT,
  SIDE_DRAWER_WIDTH,
} from './ModalDrawerStyles'

const ModalDrawer = ({
  style,
  children,
  sideDrawer,
  topDrawer,
  openDrawer,
  setOpenDrawer,
  leftDrawer,
  poiDrawer,
  headerCalc,
  slideFrom,
}) => {
  const { uiConfig } = useContext(StoreContext)

  const { appRef, headerHeight, mortgageCalculatorOpen } = uiConfig

  const offsetWd = style ? style.width || SIDE_DRAWER_WIDTH : SIDE_DRAWER_WIDTH
  const drawerHt =
    appRef && appRef.current
      ? appRef.current.offsetHeight - headerHeight
      : '100%'
  const drawerSide = slideFrom || 'right'
  const myHeight = style && style.height ? style.height : drawerHt
  const myMarginTop = headerCalc ? 215 : headerHeight
  const sideDrawerStyle = useSpring({
    [drawerSide]: openDrawer ? `0px` : `-${offsetWd}px`,
    height: myHeight,
    marginTop: myMarginTop,
  })
  const drawerStyle = useSpring({
    top: openDrawer ? '0px' : topDrawer ? '-200%' : '100%',
    config: config.default,
  })
  const activeStyle = sideDrawer ? sideDrawerStyle : drawerStyle
  if (!appRef) {
    return null
  }

  return ReactDom.createPortal(
    <Root>
      <animated.div
        style={{ ...activeStyle, ...style }}
        className={
          sideDrawer
            ? classes.sideDrawer
            : topDrawer
            ? clsx(classes.drawer, classes.topDrawer)
            : classes.topDrawer
        }
      >
        <div className={classes.header}>
          <IconButton
            className={classes.clearButton}
            aria-label="Clear"
            color="primary"
            onClick={() => setOpenDrawer(false)}
            size="large"
          >
            <ClearIcon />
          </IconButton>
        </div>
        <div
          className={classes.drawerContent}
          style={{
            height: poiDrawer ? '100%' : 'auto',
          }}
        >
          {children}
        </div>
      </animated.div>
    </Root>,
    appRef.current
  )
}

ModalDrawer.propTypes = {
  openDrawer: PropTypes.bool.isRequired,
  setOpenDrawer: PropTypes.func.isRequired,
  sideDrawer: PropTypes.bool,
  topDrawer: PropTypes.bool,
  style: PropTypes.object,
  poiDrawer: PropTypes.bool,
}

ModalDrawer.defaultProps = {
  sideDrawer: false,
  topDrawer: false,
  style: {},
  poiDrawer: false,
}

export default ModalDrawer
